//#region src/webcomponents/utils/normalize-props.js
function e(e) {
	return e === 0 ? void 0 : e;
}
function t(e) {
	if (e) {
		for (let t of Object.values(e)) if (t) return e;
	}
}
function n(e) {
	return e === "" ? void 0 : e;
}
//#endregion
export { t as n, n as r, e as t };
